var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-page"},[_c('div',{staticClass:"box",style:({background:_vm.bgColor,marginLeft:_vm.edge+'px',marginRight:_vm.edge+'px',marginTop:_vm.udEdge+'px'}),domProps:{"innerHTML":_vm._s(_vm.richText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }